<template>
  <div class="moqu-account-manage">
    <!-- 顶部操作栏 -->
    <div class="operation-bar">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            v-model="filterForm.username"
            placeholder="请输入账号名称"
            clearable
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <el-button type="primary" @click="handleAdd">新增账号</el-button>
          <el-button type="warning" @click="handleRefreshAllTokens"
            >更新所有Token</el-button
          >
        </el-col>
      </el-row>
    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="username" label="账号名称" width="180"></el-table-column>
      <el-table-column prop="token" label="Token" show-overflow-tooltip>
        <template slot-scope="scope">
          <span class="token-text" @click="copyToken(scope.row.token)" title="点击复制">{{
            scope.row.token
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remaining_downloads"
        label="今日剩余次数"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <!-- <el-button type="text" @click="handleUpdateToken(scope.row)"
            >更新Token</el-button
          > -->
          <el-button type="text" class="delete-button" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>

    <!-- 新增/编辑账号对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleDialogClose"
    >
      <el-form :model="formData" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="账号名称" prop="username">
          <el-input v-model="formData.username" placeholder="请输入账号名称"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="formData.password"
            type="password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 更新Token对话框 -->
    <!-- <el-dialog title="更新Token" :visible.sync="tokenDialogVisible" width="500px">
      <el-form :model="tokenForm" :rules="tokenRules" ref="tokenForm" label-width="100px">
        <el-form-item label="Token" prop="token">
          <el-input v-model="tokenForm.token" placeholder="请输入新的Token"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tokenDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTokenForm">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import {
  addMoquAccount,
  listMoquAccount,
  moquAccountInfo,
  updateMoquAccount,
  //   updateAccountToken,
  deleteMoquAccount,
  refreshAllTokens
} from "@/api/index.js";

export default {
  name: "MoquAccountManage",
  data() {
    return {
      loading: false,
      // 筛选表单
      filterForm: {
        username: "",
      },
      // 表格数据
      tableData: [],
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      // 对话框显示控制
      dialogVisible: false,
      dialogTitle: "新增账号",
      tokenDialogVisible: false,
      // 表单数据
      formData: {
        username: "",
        password: "",
      },
      // Token表单数据
      tokenForm: {
        token: "",
        id: null,
      },
      // 表单验证规则
      rules: {
        username: [
          { required: true, message: "请输入账号名称", trigger: "blur" },
          { min: 2, max: 50, message: "长度在 2 到 20 个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 50, message: "长度在 6 到 20 个字符", trigger: "blur" },
        ],
      },
      // Token表单验证规则
      tokenRules: {
        token: [{ required: true, message: "请输入Token", trigger: "blur" }],
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取数据列表
    async fetchData() {
      this.loading = true;
      try {
        const res = await listMoquAccount({
          ...this.filterForm,
          page: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        });
        this.tableData = res.data.data;
        this.pagination.total = res.data.pagination.total;
      } catch (error) {
        console.error(error);
        this.$message.error("获取账号列表失败");
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },

    // 新增账号
    handleAdd() {
      this.dialogTitle = "新增账号";
      this.formData = {
        username: "",
        password: "",
      };
      this.dialogVisible = true;
    },

    // 编辑账号
    async handleEdit(row) {
      this.dialogTitle = "编辑账号";
      try {
        const res = await moquAccountInfo(row.id);
        this.formData = {
          id: res.data.id,
          username: res.data.username,
          password: "",
        };
        this.dialogVisible = true;
      } catch (error) {
        console.error(error);
        this.$message.error("获取账号详情失败");
      }
    },

    // 更新Token
    handleUpdateToken(row) {
      this.tokenForm = {
        token: "",
        id: row.id,
      };
      this.tokenDialogVisible = true;
    },

    // 删除账号
    handleDelete(row) {
      this.$confirm("确认删除该账号？", "提示", {
        type: "warning",
      })
        .then(async () => {
          try {
            await deleteMoquAccount(row.id);
            this.$message.success("删除成功");
            this.fetchData();
          } catch (error) {
            console.error(error);
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },

    // 提交表单
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            if (this.formData.id) {
              await updateMoquAccount(this.formData.id, this.formData);
              this.$message.success("更新成功");
            } else {
              await addMoquAccount(this.formData);
              this.$message.success("添加成功");
            }
            this.dialogVisible = false;
            this.fetchData();
          } catch (error) {
            console.error(error);
            this.$message.error("操作失败");
          }
        }
      });
    },

    // 提交Token表单
    submitTokenForm() {
      this.$refs.tokenForm.validate(async (valid) => {
        if (valid) {
          try {
            await updateAccountToken(this.tokenForm.id, this.tokenForm);
            this.$message.success("Token更新成功");
            this.tokenDialogVisible = false;
            this.fetchData();
          } catch (error) {
            console.error(error);
            this.$message.error("Token更新失败");
          }
        }
      });
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchData();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchData();
    },
    // 复制Token到剪贴板
    copyToken(token) {
      navigator.clipboard
        .writeText(token)
        .then(() => {
          this.$message.success("Token已复制到剪贴板");
        })
        .catch(() => {
          this.$message.error("复制失败");
        });
    },

    // 对话框关闭前
    handleDialogClose(done) {
      this.$refs.form.resetFields();
      done();
    },

    // 更新所有Token
    async handleRefreshAllTokens() {
      this.$confirm("确认更新所有账号的Token？", "提示", {
        type: "warning",
      })
        .then(async () => {
          try {
            await refreshAllTokens();
            this.$message.success("所有Token更新成功");
            this.fetchData();
          } catch (error) {
            console.error(error);
            this.$message.error("Token更新失败");
          }
        })
        .catch(() => {});
    }
    
    
  },
};
</script>

<style lang="scss" scoped>
.moqu-account-manage {
  padding: 20px;

  .operation-bar {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 16px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .el-select {
      width: 100%;
    }
  }

  .el-table {
    margin-top: 16px;
    .delete-button {
      color: #f56c6c;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
  .token-text {
    cursor: pointer;
    color: #409eff;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
